import { RequestCallDto } from '../models';
import api from '../http/api';

export const requestCall = (value: RequestCallDto) =>
  api.post('phone/post', value, {
    headers: { 'Content-Type': 'application/json' },
  });
